import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Table, Button, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import "react-datepicker/dist/react-datepicker.css";
import { FaTrash } from 'react-icons/fa';
import uuid from 'react-uuid';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import "../ExternalOrganisation/ExternalOrganisation.css";
import Validate from '../Validate/Validate';
import { FaChevronLeft, FaUpload } from 'react-icons/fa';
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const ViewSubscription = () => {
    const { state } = useLocation(); const navigate = useNavigate();
    const [subscriptionObj, setSubscriptionObj] = useState([]); const [loading, setLoading] = useState(true);

    const cancelSubscription = async (e, id) => {
        e.stopPropagation();
        e.preventDefault();
        toast.loading("Cancelling subscription...", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        const response = await apiGet(
            '/api/Subscription/CancelSubscription/', {
            params: { id: id }
        })
        if (response.data.status) {
            toast.success("Subscription cancelled!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            setTimeout(() => {
                window.location.reload(true);
            }, 3000);
            
        }
        else {
            toast.error("Error when cancelling subscription", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            setTimeout(() => {
                window.location.reload(true);
            }, 3000);
        }
    }   

    const populateItemData = async () => {
        try {
            if (state != null) {
                const { id } = state;
                const response = await apiGet(
                    '/api/Subscription/GetSubscription/', {
                        params: { id: id }
                }
                );
                setSubscriptionObj(response.data.content);
                setLoading(false);
            }
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }
    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);

    const backToFarmList = async () => {
        window.location = '/subscriptions';
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header d-flex justify-content-between align-items-center">
                    Subscription Plan
                </h2>
                <CardBody>
                    {loading ? <SpinnerContainer /> :
                        <div>
                            <Row>
                                <Col sm="6">
                                    <Card className="my-4">
                                        <h3 className="card-header d-flex justify-content-between align-items-center">
                                            Subscription Details
                                        </h3>
                                        <CardBody>
                                            <Row>
                                                <Col sm="2">
                                                    <span>Id</span>
                                                </Col>
                                                <Col sm="8">
                                                    <span>{subscriptionObj != undefined && subscriptionObj.basicDetails != undefined &&
                                                        subscriptionObj.basicDetails.subscriptionId
                                                    }</span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="2">
                                                    <span>Type</span>
                                                </Col>
                                                <Col sm="8">
                                                    <span>{subscriptionObj != undefined && subscriptionObj.basicDetails != undefined &&
                                                        subscriptionObj.basicDetails.type
                                                    }</span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="2">
                                                    <span>Status</span>
                                                </Col>
                                                <Col sm="8">
                                                    <span>{subscriptionObj != undefined && subscriptionObj.basicDetails != undefined &&
                                                        subscriptionObj.basicDetails.status
                                                    }</span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="2">
                                                    <span>Created</span>
                                                </Col>
                                                <Col sm="8">
                                                    <span>{subscriptionObj != undefined && subscriptionObj.basicDetails != undefined &&
                                                        subscriptionObj.basicDetails.createdOn    
                                                    }</span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="2">
                                                    <span>Current period</span>
                                                </Col>
                                                <Col sm="8">
                                                    <span>{subscriptionObj != undefined && subscriptionObj.basicDetails != undefined &&
                                                        subscriptionObj.basicDetails.currentPeriod
                                                    }</span>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col sm="6">
                                    <Card className="my-4">
                                        <h3 className="card-header d-flex justify-content-between align-items-center">
                                            Subscribed Farms
                                        </h3>
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                <th width="15%">Unique Identifier</th>
                                                                <th width="30%">Name</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {subscriptionObj != undefined && subscriptionObj.farmDetails == undefined &&
                                                                <tr><td colSpan="5" style={{ textAlign: "center" }}>Loading...</td></tr>
                                                            }
                                                            {subscriptionObj != undefined && subscriptionObj.farmDetails != undefined && subscriptionObj.farmDetails != null && subscriptionObj.farmDetails.map(item => (
                                                                <tr key={uuid()}>
                                                                    <td>{item.uniqueIdentifier}</td>
                                                                    <td>{item.name} </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="6">
                                    <Card className="my-4">
                                        <h3 className="card-header d-flex justify-content-between align-items-center">
                                            Invoices
                                        </h3>
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                <th width="15%">Amount</th>
                                                                <th width="10%">Status</th>
                                                                <th width="30%">Invoice Number</th>
                                                                <th width="25%">Created</th>
                                                                <th width="15%"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {subscriptionObj != undefined && subscriptionObj.invoices == undefined &&
                                                                <tr><td colSpan="5" style={{ textAlign: "center" }}>Loading...</td></tr>
                                                            }
                                                            {subscriptionObj.invoices != undefined && subscriptionObj.invoices != null && subscriptionObj.invoices.map(item => (
                                                                <tr key={uuid()}>
                                                                    <td>{item.amount}</td>
                                                                    <td>{item.status} </td>
                                                                    <td>{item.invoiceNumber} </td>
                                                                    <td>{item.createdOn} </td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        <a style={{ background: "none", border: "none" }} value="Export" placeholder="" href={item.pdfUrl} target='_blank'>
                                                                            <img src="/images/PDF_icon.png" className="card_icon" ></img>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                {subscriptionObj.basicDetails.status == 'active' && 
                                    <Col sm="6">
                                        <Card className="my-4">
                                            <h3 className="card-header d-flex justify-content-between align-items-center">
                                                Useful Links
                                            </h3>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <span>• Update billing information & payment methods <a href={subscriptionObj != undefined && subscriptionObj.portalSessionUrl} target='_blank'><b>here</b></a></span>
                                                    </Col>
                                                </Row>
                                                {subscriptionObj.basicDetails.status == 'active' && <Row>
                                                    <Col>
                                                        <span>• Cancel your subscription <button className="subscriptionCancelButton" onClick={(e) => cancelSubscription(e, subscriptionObj.basicDetails.subscriptionId)}><b>here</b></button></span>
                                                    </Col>
                                                </Row>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                            }
                                
                            </Row>
                            <Row>
                                <Col>
                                    <Button className="btn-back-list" color="warning" onClick={backToFarmList}><FaChevronLeft /> Back To List</Button>
                                </Col>
                            </Row>
                        </div>
                    }
                </CardBody>
            </Card>
        </div>
    );
}

export default ViewSubscription;